export default __webpack_public_path__ + "static/media/login_illustration.a5103a17.svg";